import { State } from '@progress/kendo-data-query';
import React from 'react';
import percentRecDolColumns from 'src/assets/static/view_invoice/percentRecDolColumns';

import Grid from 'src/components/GridWrapper';

const initialPercentRecDolState: State = {
  take: 1,
  skip: 0,
};

const defaultProps = {
  showColumnMenu: false,
  sortable: false,
  columns: percentRecDolColumns,
  DataItemKey: 'poTotal',
};

interface IPercentRecDolWizard {
  dataSource: any;
}

const PercentRecDolWizard: React.FC<IPercentRecDolWizard> = ({ dataSource }) => (
  <>
    <div className="mt-1 mb-1 px-1">
      <Grid
        className="percentRecGrid viewInvoiceModalGrid no_Veritcal_ScrollBar"
        dataSource={[dataSource]}
        dataState={initialPercentRecDolState}
        total={1}
        onDataStateChange={() => {}}
        {...defaultProps}
      />
    </div>
  </>
);

export default PercentRecDolWizard;
